<template>
  <ScModal
    class="confirmation-dialog"
    :show="show"
    @cancel="handleCancel"
  >
    <div class="modal-header">
      <h5 class="modal-title">
        İşlemi Onayla
      </h5>
      <button
        type="button"
        class="close"
        @click="handleCancel"
      >
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p class="text-center icon-wrapper">
        <GIcon
          name="alert-triangle"
          stroke="var(--red-500)"
          size="48px"
          class="alert-icon"
        />
      </p>
      <p v-if="dialog">
        {{ dialog }}
      </p>
      <p
        v-if="dialogAsHtml"
        v-html="dialogAsHtml"
      />
    </div>
    <div class="modal-footer">
      <ScButton
        type="button"
        variant="secondary"
        @click="handleCancel"
      >
        İptal Et
      </ScButton>
      <ScButton
        type="button"
        variant="primary"
        @click="handleConfirm"
      >
        Evet, Onaylıyorum
      </ScButton>
    </div>
  </ScModal>
</template>

<script>
import ScModal from '@trendyol/sc-ui-kit/ScModal';
import ScButton from '@trendyol/sc-ui-kit/ScButton';
import GIcon from '@trendyol-js/grace/core/GIcon';

export default {
  name: 'ConfirmDialog',
  components: {
    ScModal,
    ScButton,
    GIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: String,
      default: null,
    },
    dialogAsHtml: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleConfirm () {
      this.$emit('confirm');
      this.$emit('cancel');
    },
    handleCancel () {
      this.$emit('cancel');
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  .confirmation-dialog {
    .icon-wrapper {
      margin-bottom: 30px;
    }
    & .modal-header{
      padding: 35px 30px 25px 30px;
      & .modal-title{
        font-size: 20px !important;
      }
    }
    & .modal-body{
      padding: 0 30px;
    }
    & .modal-footer{
      margin-top: 30px;
      padding: 16px 30px;
    }

    ::v-deep .modal-dialog {
      max-height: unset !important;
    }

    @media only screen and (max-width: 480px) {
      .modal-footer {
        flex-direction: column;

        .btn {
          width: 100%;
          margin: 0;

          &:last-child {
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>
